require('icheck');
require('icheck/skins/square/square.css');
require('icheck/skins/square/blue.css');
require('font-awesome/css/font-awesome.css');
require('animate.css/animate.css');
require('bootstrap');
require('bootstrap/dist/css/bootstrap.css');
require('bootstrap-tour');
require('bootstrap-tour/build/css/bootstrap-tour.css');
require('parsleyjs');
require('parsleyjs/dist/i18n/pt-br.js');
require('velocity-animate');
require('velocity-animate/velocity.ui.js');
require('jquery-mousewheel');
require('jquery-maskmoney/dist/jquery.maskMoney');
require('jquery-mask-plugin');
require('malihu-custom-scrollbar-plugin');
require('malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css');
require('typeahead.js/dist/typeahead.bundle');
require('@progress/kendo-ui/js/kendo.all');
require('@progress/kendo-ui/css/web/kendo.common-bootstrap.css');
require('@progress/kendo-ui/css/web/kendo.bootstrap.css');
require('@progress/kendo-ui/css/web/kendo.bootstrap.mobile.css');
require('sweetalert');
require('sweetalert/dist/sweetalert.css');
require('protip');
require('protip/protip.min.css');
require('heatmap.js');
require('mapbox.js/theme/style.css');
require('leaflet-providers/leaflet-providers.js');
require('leaflet-contextmenu/dist/leaflet.contextmenu.css');
require('leaflet-contextmenu/dist/leaflet.contextmenu.js');
require('leaflet-draw/dist/leaflet.draw-src.js');
require('leaflet-draw/dist/leaflet.draw.css');
require('leaflet-easybutton/src/easy-button.css');
require('leaflet-easybutton/src/easy-button.js');
require('leaflet.markercluster/dist/MarkerCluster.Default.css');
require('leaflet.markercluster/dist/MarkerCluster.css');
require('leaflet.markercluster/dist/leaflet.markercluster-src.js');
require('leaflet.sync/L.Map.Sync.js');

// Others
require('polyline-encoded/Polyline.encoded.js');
require('./libs/flat-ui/css/flat-ui.css');
require('./libs/jquery-scrolltabs/css/scrolltabs.css');
require('./libs/jquery-scrolltabs/js/jquery.scrolltabs');



// WEBPACK FOOTER //
// ./src/vendor.js